/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const XTwitter = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="X (twitter) 24">
      <path
        fill="#1C1C1C"
        fillRule="evenodd"
        d="M9.242 12.64 1 2h6.528l5.087 6.576L18.05 2.03h3.596l-7.292 8.793L23 22h-6.508l-5.51-7.112-5.88 7.092H1.487l7.755-9.34Zm8.198 7.389L5.003 3.97h1.576L19 20.03h-1.56Z"
        className="Union"
        clipRule="evenodd"
      />
    </g>
  </svg>
);

export const XTwitterIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'x-twitter-icon'}
      icon={XTwitter}
      {...props}
      size={size}
    />
  );
};
